ready = ->
  $("body").on "click", ".add-specimen-type-btn", (e) ->
    $('#edit_specimen_type').addClass 'hide'
    $('#register_specimen_type').removeClass 'hide'

  $("body").on "click", ".edit-specimen-type-btn", (e) ->
    $('#edit_specimen_type').removeClass 'hide'
    $('#register_specimen_type').addClass 'hide'

$(document).on 'turbolinks:load', ready